"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerChannel = void 0;
const topic_1 = require("../../topic");
const PLAYER_CHANNEL = 'player';
class PlayerChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = PLAYER_CHANNEL;
        this.topics = {
            CTA_NRS_Open: new topic_1.Topic('CTA_NRS_Open', PLAYER_CHANNEL, this._logger),
            CTA_Login_Request_Submit: new topic_1.Topic('CTA_Login_Request_Submit', PLAYER_CHANNEL, this._logger),
            CTA_MyAccount_Open: new topic_1.Topic('CTA_MyAccount_Open', PLAYER_CHANNEL, this._logger),
            CTA_MyAccount_Open_Challenges: new topic_1.Topic('CTA_MyAccount_Open_Challenges', PLAYER_CHANNEL, this._logger),
            CTA_MyAccount_Open_Reports: new topic_1.Topic('CTA_MyAccount_Open_Reports', PLAYER_CHANNEL, this._logger),
            CTA_Open_LoyaltyIndication: new topic_1.Topic('CTA_Open_LoyaltyIndication', PLAYER_CHANNEL, this._logger),
            CTA_Bet_Failed: new topic_1.Topic('CTA_Bet_Failed', PLAYER_CHANNEL, this._logger),
            playerPreferences: new topic_1.Topic('playerPreferences', PLAYER_CHANNEL, this._logger),
            playerSegmentationUpdate: new topic_1.Topic('playerSegmentationUpdate', PLAYER_CHANNEL, this._logger),
            b2cPlayerSegmentation: new topic_1.Topic('b2cPlayerSegmentation', PLAYER_CHANNEL, this._logger),
            openLogin: new topic_1.Topic('openLogin', PLAYER_CHANNEL, this._logger),
            showBetslip: new topic_1.Topic('showBetslip', PLAYER_CHANNEL, this._logger),
            addToBetslip: new topic_1.Topic('addToBetslip', PLAYER_CHANNEL, this._logger),
            openNativeApp: new topic_1.Topic('openNativeApp', PLAYER_CHANNEL, this._logger),
            confirmLocation: new topic_1.Topic('confirmLocation', PLAYER_CHANNEL, this._logger),
            loginCompletion: new topic_1.Topic('loginCompletion', PLAYER_CHANNEL, this._logger),
            registerCompletion: new topic_1.Topic('registerCompletion', PLAYER_CHANNEL, this._logger),
            favouriteSports: new topic_1.Topic('favouriteSports', PLAYER_CHANNEL, this._logger),
            favouriteUpdate: new topic_1.Topic('favouriteUpdate', PLAYER_CHANNEL, this._logger),
            handlePendingAction: new topic_1.Topic('handlePendingAction', PLAYER_CHANNEL, this._logger),
            gamblingSessionUpdate: new topic_1.Topic('gamblingSessionUpdate', PLAYER_CHANNEL, this._logger),
        };
    }
}
exports.PlayerChannel = PlayerChannel;
//# sourceMappingURL=player.channel.js.map